import { h } from 'preact';
import { PLAYER_CONTROL_EVENT, APPLICATION_EVENT, PLAYER_EVENT } from 'constants/events';

export const Interactivity = props => {
    const onClick = event => {
            if (props.pause) {
                props.bus.emit(PLAYER_CONTROL_EVENT.PAUSE);
            }

            if (props.releaseGate) {
                props.bus.emit(APPLICATION_EVENT.RELEASE_GATE);
            }

            if (props.loopback && !loopbackCleared) {
                loopbackCleared = true;
            }
        },
        [startTime, endTime] = props.timing,
        style = {
            position: 'relative',
            textDecoration: 'inherit',
            color: 'inherit',
            cursor: 'pointer'
        };

    let loopbackCleared = props.loopback ? false : true;

    props.bus.on(PLAYER_EVENT.TIME_UPDATE, (event, playerAdapter) => {
        if (!loopbackCleared && playerAdapter.currentTime >= endTime) {
            props.bus.emit(PLAYER_CONTROL_EVENT.CURRENT_TIME, startTime);
        }
    });

    return (
        <a tab-index="1" href={ props.gotoLink } target="_blank" onClick={ onClick } style={ style }>
            { props.children }
        </a>
    );
};